import { useState } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";

/**
 * Painel de diagnóstico Sentry. Aparece quando ?sentry_debug=1 na URL.
 * Mostra status do DSN e permite enviar um evento de teste (não filtrado).
 */
export function SentryDebugPanel() {
  const location = useLocation();
  const [sent, setSent] = useState(false);
  const params = new URLSearchParams(location.search);
  if (params.get("sentry_debug") !== "1") return null;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const hasDsn = Boolean(dsn?.trim());

  const sendTest = () => {
    if (!hasDsn) return;
    Sentry.captureException(new Error("DEBUG-SENTRY-PIPELINE: teste manual (sentry_debug=1)"), {
      tags: { source: "sentry-debug-manual", env: import.meta.env.MODE },
    });
    setSent(true);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 99999,
        background: "#1a1a2e",
        color: "#eee",
        padding: "12px 16px",
        borderRadius: 8,
        fontSize: 12,
        fontFamily: "monospace",
        maxWidth: 320,
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 8 }}>🔧 Sentry Debug</div>
      <div style={{ marginBottom: 6 }}>
        <strong>DSN:</strong> {hasDsn ? "✅ presente" : "❌ ausente"}
      </div>
      <div style={{ marginBottom: 8, fontSize: 11, color: "#aaa" }}>
        {hasDsn
          ? "Build tem VITE_SENTRY_DSN. Eventos podem ser enviados."
          : "Redeploy necessário após configurar VITE_SENTRY_DSN na Vercel."}
      </div>
      {hasDsn && (
        <button
          type="button"
          onClick={sendTest}
          disabled={sent}
          style={{
            padding: "6px 12px",
            background: sent ? "#333" : "#7a1c1c",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: sent ? "default" : "pointer",
            fontSize: 11,
          }}
        >
          {sent ? "Enviado ✓" : "Enviar teste agora"}
        </button>
      )}
    </div>
  );
}
